import { useState, useEffect, useReducer } from "react";
import axios from "axios";
import Button from "../ResubleComp/Button";
import camera from "../../images/camera.png";
import ClusterEdit from "./ClusterPOST/ClusterEdit";
const IndivisualClusterHeading = () => {
  const token = localStorage.getItem("TOKEN");
  let userId = localStorage.getItem("userId");
  const [follow, setFollow] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [cluster, setCluster] = useState("");
  const [update, forceUpdate] = useReducer((x) => x + 1, 0);
  const [clusterName, setClusterName] = useState("");
  const [individualopen, setindividualOpen] = useState(false);
  const [clusterProfileImage, setClusterImage] = useState("");
  const [clusterGuideLines, setClusterGuideLines] = useState("");
  const [aboutCluster, setAboutCluster] = useState("");
  // const [UpdateCluster, setUpdateCluster] = useState({
  //   clusterName:cluster.clusterName,
  //   clusterGuideLines:cluster.clusterGuideLines,
  //   aboutCluster:cluster.aboutCluster,

  // });
  const handleClose = () => {
    setindividualOpen(false);
  };

  const getClusterById = async () => {
    const clusterId = localStorage.getItem("clusterId");
    const url = baseUrl + `/api/cluster/getclusterbyname/${clusterId}`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    setCluster(response.data.data);
    console.log("setClusterNamesetClusterName", response.data.data);
    console.log("aziii =====", response);
    localStorage.setItem("clusterId", response.data.data.name);
    if (response.data.data.clusterFollwers.includes(userId)) setFollow(true);
    console.log("clusteresponse", response.data.data.clusterFollwers);
  };

  const FollowCluster = async (clusterID) => {
    const token = localStorage.getItem("TOKEN");
    const url = baseUrl + `/api/cluster/follow/${clusterID}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    // setFollow(response);
    forceUpdate();
    console.log("clusterresponse", response);
    return response;
  };

  const updateCluster = async () => {
    const formData = new FormData();
    formData.append("name", clusterName ?? "");
    formData.append("clusterProfileImage", clusterProfileImage ?? "");
    formData.append("clusterGuideLines", clusterGuideLines ?? "");
    formData.append("aboutCluster", aboutCluster ?? "");

    const url = baseUrl + `/api/cluster/update/${cluster._id}`;
    const response = await axios.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: token,
      },
    });
    console.log("responsese", response.data);
    handleClose();
    forceUpdate();
  };

  useEffect(() => {
    getClusterById();
  }, [update]);

  //router.put("/update/:clusterId", authenticate, updatedClusterById);
  const EditClusterPage = async () => {
    setindividualOpen(true);
  };

  // const onchangeHandler = (e) => {
  //   const { name, value } = e.target;
  //   setUpdatedUser((pre) => ({ ...pre, [name]: value }));
  // };
  return (
    <>
      <ClusterEdit
        individualopen={individualopen}
        handleClose={handleClose}
        baseUrl={baseUrl}
        token={token}
        forceUpdate={forceUpdate}
        updateCluster={updateCluster}
        clusterName={clusterName}
        clusterProfileImage={clusterProfileImage}
        clusterGuideLines={clusterGuideLines}
        aboutCluster={aboutCluster}
        setClusterName={setClusterName}
        setClusterImage={setClusterImage}
        setClusterGuideLines={setClusterGuideLines}
        setAboutCluster={setAboutCluster}
      />
      <div className="flex justify-center flex-col items-center text-center mt-1">
        <div className="bg-blue-500 m-auto h-[175px] mt-0 lg:w-1/2 w-full md:w-full">
          <div className="">
            <div className="flex flex-col relative">
              {!cluster.clusterProfileImage ? (
                <img
                  src={camera}
                  className="w-40 h-40 absolute top-20 left-4 rounded-full border border-blue-300"
                  alt=""
                />
              ) : (
                <img
                  src={cluster.clusterProfileImage}
                  className="w-40 h-40 rounded-full absolute top-20 left-4"
                  alt=""
                />
              )}
            </div>
          </div>
        </div>
        <div className="m-auto mb-14 h-auto border border-cyan-600 rounded-md flex items-center justify-between lg:w-1/2 md:w-full w-full">
          <div className="flex flex-col items-start p-3 mt-16 h-auto">
            <h1 className="text-2xl font-bold">{cluster.name}</h1>
            <h1 className="lg:text-lg md:text-lg text-sm lg:text-left md:text-left text-left">
              {cluster.aboutCluster}
            </h1>
            {cluster.clusterGuideLines ? (
              <h1 className="text-sm text-left my-2">{`Guideline: ${cluster.clusterGuideLines}`}</h1>
            ) : (
              ""
            )}
            <h1 className="flex gap-2 text-sm">
              <img
                src="https://png.pngtree.com/png-vector/20190903/ourmid/pngtree-calendar-icon-in-trendy-style-isolated-background-png-image_1718934.jpg"
                className="w-[25px] h-[25px] rounded-full"
                alt=""
              />
              {new Date(cluster.createdAt).toLocaleTimeString("en", {
                year: "numeric",
                month: "long",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
                timeZone: "IST",
              })}
            </h1>

            <div className="flex gap-2 text-sm">
              <img
                src="https://cdn-icons-png.flaticon.com/512/33/33308.png"
                className="w-[25px] h-[25px] rounded-full"
                alt=""
              />
              <span>Members: {cluster.clusterFollwers?.length + 1}</span>
            </div>
          </div>
          <div className="flex items-center mb-40 pr-5 gap-3">
            {cluster?.createdBy?.user && cluster.createdBy.user !== userId && (
              <Button
                secondary
                className="px-3 py-2 rounded-lg mt-5 cursor-pointer"
                onClick={() => {
                  FollowCluster(cluster._id);
                }}
              >
                {follow ? "Joined" : "join"}
              </Button>
            )}
            {cluster?.createdBy?.user && cluster.createdBy.user === userId && (
              <Button
                primary
                className="px-3 py-2 rounded-lg mt-5 cursor-pointer"
                onClick={() => {
                  EditClusterPage();
                }}
              >
                Update
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default IndivisualClusterHeading;

{
  /* {userId === cluster.createdBy.user && follow.status === 200
              ? "Joined"
              : "Join"} */
}
{
  /* {cluster?.createdBy?.user &&
            cluster.createdBy.user === userId &&
            follow.status === 200
              ? "Joined"
              : "Join"} */
}

{
  /* {follow.status === 200 ? "Joined" : "Join"} */
}
{
  /* {follow.status === 200 && "Joined"} */
}
{
  /* {follow.status === 400 || (404 && "Join")} */
}
